import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const { user, profile, getSubscriptionStatus, isAdmin, logoutUser } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logoutUser();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const getSubscriptionBadge = () => {
    const status = getSubscriptionStatus();
    const badges = {
      unpaid: { color: 'gray', text: 'Unpaid' },
      payment_pending: { color: 'yellow', text: 'Payment Pending' },
      active: { color: 'green', text: 'Active' },
      expired: { color: 'red', text: 'Expired' }
    };
    
    const badge = badges[status] || badges.unpaid;
    return (
      <span className={`subscription-badge badge-${badge.color}`}>
        {badge.text}
      </span>
    );
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-brand">
          <Link to="/" className="brand-link">
            <h1>Zed Scholar</h1>
          </Link>
        </div>

        {/* Mobile menu button */}
        <button 
          className="mobile-menu-button"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-menu ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="navbar-links">
            <Link to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Home
            </Link>
            <Link to="/about" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              About
            </Link>
            <Link to="/pricing" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Pricing
            </Link>
            <Link to="/contact" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
              Contact
            </Link>
            
            {user && (
              <>
                <Link to="/dashboard" className="nav-link" onClick={() => setMobileMenuOpen(false)}>
                  Dashboard
                </Link>
                {isAdmin() && (
                  <Link to="/admin" className="nav-link admin-link" onClick={() => setMobileMenuOpen(false)}>
                    Admin
                  </Link>
                )}
              </>
            )}
          </div>
          
          <div className="navbar-actions">
            {user ? (
              <div className="navbar-user">
                <div className="user-info">
                  <span className="user-name">{profile?.displayName}</span>
                  {getSubscriptionBadge()}
                </div>
                <button onClick={handleLogout} className="btn btn-secondary btn-sm">
                  Logout
                </button>
              </div>
            ) : (
              <div className="navbar-auth">
                <Link to="/login" className="btn btn-secondary btn-sm" onClick={() => setMobileMenuOpen(false)}>
                  Login
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
